import { DropdownOption } from "src/createEntityModal/types";

export interface Currency {
  code: string;
  symbol: string;
  name: string;
}
export interface ModelTemplate {
  modelTemplateType: string;
  modelTemplateVersion?: string;
  useMoodysSpreadingGuideline?: boolean;
}

export interface ModelTemplateDropdownOption {
  label: string;
  value: ModelTemplate;
}

export interface RawMetadataConfigItem {
  values?: string[] | ModelTemplate[];
  isEnabled: boolean;
  isRequiredOnUpload: boolean;
  isRequiredOnComplete: boolean;
  shouldDisplayOnUpload: boolean;
  defaultValue?: string | ModelTemplate;
  label: string;
  isDisabledView: boolean;
  isPerPeriod?: boolean;
  maxLength?: string | number;
  maxValue?: number;
  displayMetadataId?: boolean;
}

export interface RawMetadataConfig {
  [key: string]: RawMetadataConfigItem;
}

export type MetadataInputOption = DropdownOption | ModelTemplateDropdownOption;

export interface MetadataInput {
  options: MetadataInputOption[];
  defaultValue?: MetadataInputOption | null;
  isRequiredOnUpload: boolean;
  isRequiredOnComplete: boolean;
  label: string;
  formKey: string;
  inputType: string;
  isDisabledView?: boolean;
  isPerPeriod?: boolean;
  isNumericType?: boolean;
  isDateType?: boolean;
  maxLength?: number | string;
  maxValue?: number;
  displayMetadataId?: boolean;
}

export interface PaginationOptions {
  pageSize: number;
}

export interface MetadataFrontEndConfig {
  uploadForm: MetadataInput[];
  aboutPage: MetadataInput[];
  rawConfig: RawMetadataConfig;
}

export interface MetadataFormStateItem {
  shouldShowErrorNegative?: boolean;
  shouldShowError: boolean;
  value: null | string | ModelTemplate;
}
export interface MetadataFormState {
  [key: string]: MetadataFormStateItem;
}

export interface MetadataId {
  fieldName: string;
  id: string;
}

export interface MetadataItemsContainingIds {
  name: string;
  id?: string;
  value: any;
  valueForP2?: any;
}

export enum MetadataFormKeys {
  TemplateType = "templateType",
  SourceCurrency = "currency",
  StatementType = "statementType",
  StatementClassification = "statementClassification",
  AuditMethod = "auditMethod",
  AuditorName = "auditorName",
  RoundingUnit = "roundingUnit",
  QCTeam1 = "qaTeam1",
  QCTeam2 = "qaTeam2",
  Period = "period",
  Language = "language",
  Consolidation = "consolidation",
  Periods = "periods",
  BalanceSheetDate = "balanceSheetDateEndDate"
}

interface PeriodValue {
  period: string;
  value: string | ModelTemplate | null;
}

export interface MetadataItem {
  name: string | number;
  value?: string | ModelTemplate | null;
  periodValues?: PeriodValue[];
  valueForP2?: string | ModelTemplate | null;
}

export interface MetadataPayload {
  items: MetadataItem[] | [];
  isFE: boolean;
}

export interface UpdateMetadataConfigPayload extends MetadataPayload {
  userId: string;
  spreadId: string;
  spreadVersion: number;
  isFE: boolean;
}



// WEBPACK FOOTER //
// ./src/metadata/types.ts